import { Branche, Role } from 'entities/Roles';
import { GetUserBranches } from 'entities/AADGroup/interfaces';
import {
  GET_ROLES_REQUEST,
  GET_ROLES_SUCCESS,
  GET_ROLES_ERROR,
  SET_BRANCH_TITLE,
  GET_BRANCHES_REQUEST,
  GET_BRANCHES_SUCCESS,
  GET_BRANCHES_ERROR,
  GET_USER_BRANCHES_REQUEST,
  GET_USER_BRANCHES_SUCCESS,
  GET_USER_BRANCHES_FAILURE,
} from './constants';

export const getRolesRequest = (id: number) => ({
  type: GET_ROLES_REQUEST,
  payload: id,
});

export const getRolesSuccess = (roles: Role[]) => ({
  type: GET_ROLES_SUCCESS,
  payload: { roles },
});

export const getRolesError = (error: Error | null) => ({
  type: GET_ROLES_ERROR,
  payload: error,
});

export const setReduxBranchTitle = (branchTitle: Branche) => ({
  type: SET_BRANCH_TITLE,
  payload: branchTitle,
});

export const getAllBranchRequest = () => ({
  type: GET_BRANCHES_REQUEST,
});

export const getAllBranchSuccess = (branches: any) => ({
  type: GET_BRANCHES_SUCCESS,
  payload: branches,
});

export const getAllBranchError = (error: Error | null) => ({
  type: GET_BRANCHES_ERROR,
  payload: error,
});

export const getUserBranchesRequest = (userId?: number) => ({
  type: GET_USER_BRANCHES_REQUEST,
  payload: userId,
});

export const getUserBranchesSuccess = (aadGroups: GetUserBranches) => ({
  type: GET_USER_BRANCHES_SUCCESS,
  payload: { body: aadGroups.body },
});

export const getUserBranchesFailure = (error: any) => ({
  type: GET_USER_BRANCHES_FAILURE,
  payload: error,
});

export type Actions =
  | ReturnType<typeof getRolesRequest>
  | ReturnType<typeof getRolesSuccess>
  | ReturnType<typeof getRolesError>
  | ReturnType<typeof setReduxBranchTitle>
  | ReturnType<typeof getAllBranchRequest>
  | ReturnType<typeof getAllBranchSuccess>
  | ReturnType<typeof getAllBranchError>
  | ReturnType<typeof getUserBranchesRequest>
  | ReturnType<typeof getUserBranchesSuccess>
  | ReturnType<typeof getUserBranchesFailure>;
